import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';

const HomeIcon = () => {
    return <FontAwesomeIcon icon={faHome} size="lg" />;
};

export default HomeIcon;
